<template lang="pug">
  .request-builder-data
    .search
      input(type="text",:placeholder="'request-builder-search'|translate",v-model="search")
    .list
      drag.elem(:transfer-data="{ d }",@click.native="edit(d)",v-for="d in data",v-if="!isActive(d)&&searchFn(d)",:key="d")
        .span {{d}}
    drop.selected(@drop="handleDrop")
      .placeholder(v-if="empty()") {{'request-builder-placeholder'|translate}}
      .elem(v-for="d in data",v-if="isActive(d)",:key="d")
        span(@click="edit(d)") {{d}}
        i.fpui.fpui-remove(@click="removeAll(d)")
</template>

<script>
  import Vue from 'vue'
  import DataModal from './DataModal'
  import {uniq} from 'lodash'

  export default {
    props: {
      dataset: Object,
      value: Object,
      order: Object
    },
    data () {
      return {
        search: ''
      }
    },
    methods: {
      add (key, values) {
        let value = Object.assign({}, this.value)
        Vue.set(value.fields, key, values)
        this.$emit('input', value)
      },
      remove (key) {
        let value = Object.assign({}, this.value)
        Vue.delete(value.fields, key)
        this.$emit('input', value)
      },
      addOrder (key, values) {
        let order = Object.assign({}, this.order)
        Vue.set(order, key, values)
        this.$emit('inputOrder', order)
      },
      removeOrder (key) {
        let order = Object.assign({}, this.order)
        Vue.delete(order, key)
        this.$emit('inputOrder', order)
      },
      handleDrop (data) {
        this.edit(data.d)
      },
      searchFn (key) {
        if (!this.search) return true
        return key.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
      },
      isActive (key, cm) {
        if (!this.value || !this.value.fields[key]) return false
        if (!cm) return this.value.fields[key].length > 0
        return this.value.fields[key].indexOf(cm) !== -1
      },
      empty () {
        if (!this.value || !this.value.fields) return true
        return Object.keys(this.value.fields).length === 0
      },
      removeAll (key) {
        let value = Object.assign({}, this.value)
        Vue.delete(value.fields, key)
        this.$emit('input', value)
        let order = Object.assign({}, this.order)
        Vue.delete(order, key)
        this.$emit('inputOrder', order)
      },
      edit (data) {
        this.$modal.show(DataModal, {
          data: data,
          value: this.value.fields[data],
          order: (this.order && this.order[data]) || '',
          computes: this.computes,
          confirm: (values, orderValues) => {
            if (values.length) {
              this.add(data, values)
              if (orderValues) {
                this.addOrder(data, orderValues)
              } else {
                this.removeOrder(data)
              }
            } else {
              this.remove(data)
            }
          }
        }, {
          height: 'auto'
        })
      }
    },
    computed: {
      computes () { return this.dataset.compute_mods },
      data () {
        return uniq(this.dataset.data.concat(this.dataset.scales)).sort()
      }
    }
  }
</script>

<style lang="less">
.request-builder-data {
  height: 100%;
  position: relative;
  .list {
    overflow-y: auto;
    max-height: calc(~"100% - 80px");
  }
}
</style>
